var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.75082V22.1024C0 23.9618 0.732813 25.7446 2.04531 27.0571L21.2953 46.3071C24.0297 49.0414 28.4594 49.0414 31.1938 46.3071L45.7953 31.7055C48.5297 28.9711 48.5297 24.5414 45.7953 21.8071L26.5453 2.55707C25.2328 1.24457 23.45 0.511757 21.5906 0.511757H5.25C2.35156 0.500819 0 2.85238 0 5.75082ZM12.25 9.25082C13.1783 9.25082 14.0685 9.61957 14.7249 10.2759C15.3813 10.9323 15.75 11.8226 15.75 12.7508C15.75 13.6791 15.3813 14.5693 14.7249 15.2257C14.0685 15.8821 13.1783 16.2508 12.25 16.2508C11.3217 16.2508 10.4315 15.8821 9.77513 15.2257C9.11875 14.5693 8.75 13.6791 8.75 12.7508C8.75 11.8226 9.11875 10.9323 9.77513 10.2759C10.4315 9.61957 11.3217 9.25082 12.25 9.25082Z",
    fill: "#828284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.569407847e0971460da6b1e6b090bb5e.svg";
export { ForwardRef as ReactComponent };